import React from 'react';
import { NudosButton, NudosGenericModal, NudosModalContent } from '../index';
import BordOneToneIcon from '../BordOneToneIcon/BordOneToneIcon';
import './BordModalConfirm.scss';

interface IBordModalConfirmProps {
  onAccept: () => void;
  onCancel: () => void;
  isLoading: boolean;
  isDisabled: boolean;
  title: string | JSX.Element;
  subtitle?: string;
  textButtonAccept?: string;
  textButtonCancel?: string;
  clickOutsideCallback?: () => void;
  closeModalCallback?: () => void;
  customSizeIcon?: number;
  customClassNameTitle?: string;
  customClassNameBordModalConfirm?: string;
}

const BordModalConfirm: React.FC<IBordModalConfirmProps> = ({
  onAccept,
  onCancel,
  isLoading,
  isDisabled,
  title,
  subtitle,
  textButtonAccept,
  textButtonCancel,
  clickOutsideCallback,
  closeModalCallback,
  customSizeIcon,
  customClassNameTitle = '',
  customClassNameBordModalConfirm = ''
}) => {
  return (
    <NudosGenericModal
      closeModalCallback={closeModalCallback}
      clickOutsideCallback={clickOutsideCallback}
      modalContent={
        <NudosModalContent
          customWidth="466px"
          customHeight="auto"
          startHeader
          excludeHeader
          customHeaderClass="pl-32"
          isSectionContainerFull
          CustomModalComponent={
            <div className={`contentBordModalConfirm ${customClassNameBordModalConfirm}`}>
              <div className={`contentIcon ${subtitle ? '' : 'withMargin'}`}>
                <BordOneToneIcon
                  variant="triangleAlertCircle"
                  standardSize={52}
                  customWidth={customSizeIcon ? `${customSizeIcon}px` : '36px'}
                />
              </div>
              <h2 className={`${subtitle ? 'title' : 'title withMargin'} ${customClassNameTitle}`}>{title}</h2>
              {subtitle && <p className="subtitle">{subtitle}</p>}
              <div className="buttons">
                <NudosButton
                  buttonText={textButtonCancel}
                  handleClick={onCancel}
                  isButtonDisabled={isDisabled}
                  isButtonLoading={isLoading}
                  customWidth="180px"
                  customHeight="38px"
                  colorPalette="secondary"
                  componentSize="small"
                />
                <NudosButton
                  buttonText={textButtonAccept}
                  handleClick={onAccept}
                  isButtonDisabled={isDisabled}
                  isButtonLoading={isLoading}
                  customWidth="180px"
                  customHeight="38px"
                  colorPalette="primary"
                  componentSize="small"
                />
              </div>
            </div>
          }
        />
      }
    />
  );
};

export default BordModalConfirm;
